import { createFormContext } from "@mantine/form";
import { Asserts } from "yup";
import marcoAtuacaoSchema from "./marco-atuacao-schema";

type FormInputs = Asserts<typeof marcoAtuacaoSchema>;

const [AtuacaoFormProvider, useAtuacaoFormContext, useAtuacaoForm] = createFormContext<FormInputs>();

export { AtuacaoFormProvider, useAtuacaoFormContext, useAtuacaoForm };
